import React from 'react';

import { Report } from 'graphql-api';

function GustoIntegrationButton({ report }: { report: Report }): JSX.Element {
  async function handleGustoIntegrationClick(): Promise<void> {
    window.location.href = `${process.env.REACT_APP_GUSTO_OAUTH_URL ?? ''}?client_id=${
      process.env.REACT_APP_GUSTO_CLIENT_ID ?? ''
    }&redirect_uri=${window.location.origin}/integrations/gusto/oauth/callback?reportId=${
      report.id
    }&response_type=code`;
  }

  return (
    <button
      className="btn-secondary"
      onClick={() => {
        void handleGustoIntegrationClick();
      }}>
      Connect
    </button>
  );
}

export default GustoIntegrationButton;
